import React, { ReactNode, useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface IModal {
  open: boolean;
  title?: string;
  onClose: (arg: boolean) => void;
  hideClose?: boolean;
  children: ReactNode;
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

export const Modal = (props: IModal) => {
  const { disableBackdropClick, disableEscapeKeyDown, open, hideClose, title, onClose, children, maxWidth } = props;
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClose = (event: any, reason: any) => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return false;
    }

    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return false;
    }

    if (typeof onClose === 'function') {
      onClose(false);
      setIsOpen(false);
    }
  };

  const handleOnClickClose = () => {
    onClose(false);
    setIsOpen(false);
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <Dialog open={isOpen} onClose={handleOnClose} scroll="paper" maxWidth={maxWidth || 'lg'}>
      <DialogTitle>
        <Typography variant="button" align="center" display="block" style={{ marginLeft: '20px', fontSize: '15px' }}>
          {title || ''}
          {!hideClose && (
            <IconButton aria-label="close" onClick={handleOnClickClose} style={{ padding: '1px', float: 'right' }}>
              <CloseIcon />
            </IconButton>
          )}
        </Typography>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
